import { Navigate, RouteObject, createBrowserRouter } from "react-router-dom";
import App from "../layout/App";
import LoginPage from "../../features/users/LoginPage";
import RequireAuth from "./RequireAuth";
import TestErrors from "../../features/errors/TestError";
import ServerError from "../../features/errors/ServerError";
import GroupFormPage from "../../features/group/GroupFormPage";
import SettingsPage from "../../features/settings/SettingsPage";
import AccountPage from "../../features/users/AccountPage";
import SyncPage from "../../features/sync/SyncPage";
import ExitIframe from "./ExitIframe";
import FulfillmentAuditPage from "../../features/fulfillmentAudit/FulfillmentAuditPage";
import SyncHealthDashboard from "../../features/home/SyncHealthDashboard";
import PaymentReconciliationPage from "../../features/paymentReconciliation/PaymentReconciliationPage";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
        children: [
            {element: <RequireAuth />, children: [  
                {path: '/', element: <SyncHealthDashboard />},
                {path: 'dashboard', element: <SyncHealthDashboard />},
                {path: 'sync-health', element: <Navigate replace to="/dashboard" />},
                {path: 'groups', element: <GroupFormPage />},
                {path: 'groups/:id', element: <GroupFormPage key='manage' />},
                {path: 'creategroup', element: <GroupFormPage key='create' />},
                {path: 'settings', element: <SettingsPage />},
                {path: 'sync', element: <SyncPage />},
                {path: 'fulfillment-audit', element: <FulfillmentAuditPage />},
                {path: 'payment-reconciliation', element: <PaymentReconciliationPage />},
                {path: 'account', element: <AccountPage />},
                {path: 'errors', element: <TestErrors />}
            ]},
            {path: 'login', element: <LoginPage />},
            {path: 'not-found', element: <Navigate replace to='/dashboard' />},
            {path: 'server-error', element: <ServerError />},
            {path: '*', element: <Navigate replace to='/not-found' />},
        ]
    },
    {
        path: '/exit-iframe',
        element: <ExitIframe />
    }
]

export const router = createBrowserRouter(routes);
